export default __webpack_public_path__ + "static/media/comments-alt.e7fdd900.svg";